<template>
    <v-app-bar app class="indigo darken-3">
        <h1 class="title bold text-center white--text" style="width: 100%;">
            {{ title }}
        </h1>
    </v-app-bar>
</template>

<script>
export default {
    name: 'Toolbar',
    props: {
        title: String,
        hideToggle: Boolean,
        hideUserDropdown: Boolean
    },
    computed: {
        icon() {
            return this.$store.state.isMenuVisible ? "angle-left" : "angle-down"
        }
    },
    methods: {
        toggleMenu() {
            this.$store.commit('parameters/toggleMenu')
        }
    }
}
</script>

<style>
    /* .title {
        font-size: 1.2rem;
        color: #fff;
        font-weight: 100;
        flex-grow: 1;
        text-align: center;
    }

    .title a {
        color: #FFF;
        text-decoration: none;
    }

    .title a:hover {
        color: #FFF;
        text-decoration: none;
    } */
</style>
